import { CaseState, ViewMode } from "app/area/case/types-store";
import { RenderMode } from "app/types-shared";

export const hideTileDetails = ( state: CaseState, uiEngineProps: any): Partial<any> => {
  const { renderMode, viewMode } = state;

  return {
    hideTileDetails:
      renderMode === RenderMode.read && viewMode === ViewMode.scroll
  };
};
